/* eslint-disable import/prefer-default-export */
export const capitalize = (word: string) => `${word[0].toUpperCase()}${word.substring(1)}`;
